import { apiGet, apiPost } from './http'

export const general = async () => apiGet('/general/data')

export const companies = async id => apiGet(`/general/companies/${id}`)

export const buildings = async id => apiGet(`/general/buildings/${id}`)

export const roles = async id => apiGet(`/general/roles/${id}`)

export const apartments = async request =>
  apiPost(`/general/apartments/${request.buildingId}`, request)

export const commonareas = async id => apiGet(`/general/commonareas/${id}`)

export const frequency = async () => apiGet('/general/frequency')

export const personnelType = async () => apiGet('/general/personnel/type')

export const getSignedUrl = async request =>
  apiPost('/general/getsignedurl', request, { auth: true })
